{
  "comment": "M10 P2a1 (hull tiers spec §3.1, §4.3, §5, §6.1; plan 2026-10-10-m10-p2 §3.1): the authoring source for strategic hulls. Nothing reads it at runtime in P2a1; P2a2's build-time compile writes hulls.json from it. sizes: the strategic fields per size band, keyed by the bands.json ids (lengths, dock modes and local weights stay in bands.json): tollClass, claimable, mkFractions (Mk I/II/III share of the hull rating), stockMk (the Mk a new hull of that band ships with; absent = the career start fit), crew [min, max]. roles: the 12 hull roles (the Capital is an XL station template, P6); classByBand maps each band the role builds to its role class (the role's bands are its keys); device is the signature device; aiJobs are the strategic ROLE jobs its hulls take; templates (band rating stats) stay empty until P4b1. M10 P4b1a2 (plan 2026-10-15-m10-p4b §3.1, inert: no row uses them until P4b1c): templates.<band> per cell a P4b line hull or variant uses, with the class ranges of the rows the cell types (hold t, price cr, crewRange heads; the data.ts load rule reads hold and crewRange instead of fleet.json classes); S/M stats at the role legacy median, the L cells at capacity and strength parity (escort L strength 18 × Varro 1.12 = 20.16, 3 patrol units at roleUnit 6, strength per build credit within ±25% of the patrol S/M median; miner L 360 t = 3 units, ≥ 2.5× the 120 t miner M at stock fit); miner S and bomber M are ranges-only cells (variants take their stats from their bases). makers: keyed by faction id (varro_security = Varro, raider = the Wreckers); kind manufacturer, rebuilder or operator; doctrine holds the strategic multipliers of spec §4.3 (cargo, strength, toughness, buildCost; absent = 1; operators have none in 1.0); line is the shipyard's doctrine string. lines: one per maker line, id maker.role unless noted; legacy hulls name an existing hulls.json row by id and keep its authored stats (model is the display model, def the ships.json def, band the def's resolved band; hauler_large is L from P3c1). unlined: hulls on no maker line (the guardian rebuilt interceptor has no maker until the story owner decides at P4b1). variants: a base row (line hull, variant or unlined), its def, an optional role and roles, overrides, flags and sale (M10 P4b1a1). M10 P4b1c (plan 2026-10-15-m10-p4b §3.2): the first eight and the three relics. Line hulls: the HX-4 Gannet (tethys.miner L), the FX-1 Warhound (varro_security.escort L, class frigate, roles patrol), the WB-8 Skua (tethys.salvager L, roles []), the EC-3 Picket (holdfast.interceptor S, roles patrol), the PF-1 Wayfinder (holdfast.survey S, roles []) and the DS-2 Delver (holdfast.miner M, roles []; a plain line hull, plan Q1), each with lengthM (spec §5.1; the Delver its 66 m concept). Variants: V1 KT-3P (the Kestrel as miner S: 40 t, Tethys doctrine on its strength and hull), V6 CV-2B (the corvette as bomber M: 40 t, Varro doctrine on its strength and hull), V10-V12 the relics (relic, hulk only). Every new row is sale false (a variant's own sale: its bases are sold) and roles [] but the Gannet (miner), the Warhound and the Picket (patrol); no roles.json mix or buyer mix names any. The three L rows were retired until flip 1 (P4b8b), which removed the key with the levelTwoGuarantee entry and seeding revision 3; they now compile live (sale false: the AI draws them only through buyerMixes and the flagship weight, both off until P4b8c/P4b8d). M10 P4a1a (plan 2026-10-11-m10-p4a §3.1), every key off or inert until P4a7a/P4a7b: sizes.<band>.minYardLevel (the lowest yard level that builds the band, canBuild) and agedHoldExempt (the band's orders skip the aged-order hold; L on at P4b8c flip 4, back off since P4b S2, D-TBD, D-1175: an aged L order holds its yard like any aged order); a line hull's sale false keeps it out of every shipyard (the cutter, the courier); licences (the licensee's yards build the maker's line; spec §4.7's day-one Varro Jackal licence to the Authority); royalty (rate × hullValue paid by a non-maker yard's owner at delivery, stopped at war; rate 0 = off); embargo (ship trade by M5 relation: economicSurcharge, the bands refused at skirmish, cancelAtWarStart, warFallback (M10 P4a W5c: when every reachable yard that can build an AI job refuses it at war, the best of them takes it at skirmish terms and the economic surcharge), and the player's standing thresholds with the yard owner); outlawRule (outlaws buy only these bands, export patterns only); canBuild.enabled (the yard-level gate); capacity (job counts in capacity units from unitBand: clamp(round(metric / roleUnit[job]), 1, maxUnits), keys exactly the ROLE ids); flagship.lWeight (the L weight in AI mixes, 0 until P4b5; 0.25 since P4b8c flip 3a). M10 P4b1a2: flagship.cap (faction → AI job → most L flagships; {} = all 0 until the flips) and buyerMixes (buyer faction → AI job → hull → weight; {} until the flips; hull checks at load in data.ts). M10 P4b8c: flip 2 buyerMixes.holdfast.patrol {holdfast_picket: 1} shipped and is held (D-TBD, D-1167: the tuned arm failed the M5 g1 holdfast-fleet soak assert), so Holdfast patrols draw the roles.json mix; flip 3a lWeight 0.25, buyerMixes.meridian.trader {hauler: 1, hauler_large: 1}, flagship.cap.meridian.trader 2 (plan Q3, Q10). M10 P4b8d: flip 3b buyerMixes.tethys.miner {miner: 1, tethys_gannet: 1}, flagship.cap.tethys.miner 1 (plan Q12); flip 3c buyerMixes.varro_security.patrol {interceptor: 0.6, gunship: 0.4, varro_warhound: 1}, flagship.cap.varro_security.patrol 1 (plan Q11). Every value is [P].",
  "sizes": {
    "S": { "tollClass": "light", "claimable": true, "mkFractions": [0.4, 0.7, 1], "crew": [1, 2], "minYardLevel": 1, "agedHoldExempt": false },
    "M": { "tollClass": "medium", "claimable": true, "mkFractions": [0.4, 0.7, 1], "crew": [2, 6], "minYardLevel": 1, "agedHoldExempt": false },
    "L": { "tollClass": "large", "claimable": false, "mkFractions": [0.7, 0.85, 1], "stockMk": 2, "crew": [6, 40], "minYardLevel": 2, "agedHoldExempt": false },
    "XL": { "tollClass": "large", "claimable": false, "mkFractions": [0.7, 0.85, 1], "stockMk": 2, "crew": [40, 400], "minYardLevel": 2, "agedHoldExempt": false }
  },
  "roles": {
    "utility": { "classByBand": { "S": "light_fighter" }, "device": "clamp_fork", "aiJobs": ["trader", "patrol"] },
    "interceptor": { "classByBand": { "S": "interceptor" }, "device": "cruise_interdictor", "aiJobs": ["patrol", "raider"],
      "templates": {
        "S": { "cargo": 10, "strength": 3, "toughness": 2, "buildCost": { "hull_plating": 20, "drive_parts": 8, "electronics": 6, "weapon_parts": 6 }, "buildSeconds": 900, "wreckLayout": "interceptor", "crew": 1, "standingReq": 10, "hold": [10, 10], "price": [70000, 70000], "crewRange": [1, 1] }
      }
    },
    "gunship": { "classByBand": { "S": "gunship" }, "device": "ball_turrets", "aiJobs": ["patrol", "raider"] },
    "bomber": { "classByBand": { "M": "bomber" }, "device": "torpedo_bay", "aiJobs": ["patrol"],
      "templates": {
        "M": { "hold": [10, 60], "price": [600000, 900000], "crewRange": [2, 6] }
      }
    },
    "escort": { "classByBand": { "M": "corvette", "L": "frigate" }, "device": "command_link", "aiJobs": ["patrol"],
      "templates": {
        "L": { "cargo": 100, "strength": 18, "toughness": 20, "buildCost": { "hull_plating": 160, "drive_parts": 40, "electronics": 40, "weapon_parts": 40, "refractory_alloy": 2 }, "buildSeconds": 7200, "wreckLayout": "corvette", "escort": true, "crew": 12, "standingReq": 50, "hold": [60, 300], "price": [1500000, 3000000], "crewRange": [6, 40] }
      }
    },
    "miner": { "classByBand": { "S": "miner", "M": "miner", "L": "miner" }, "device": "mining_booms", "aiJobs": ["miner"],
      "templates": {
        "S": { "hold": [20, 50], "price": [60000, 90000], "crewRange": [1, 1] },
        "M": { "cargo": 120, "strength": 0.3, "toughness": 3, "buildCost": { "hull_plating": 60, "drive_parts": 16, "electronics": 14, "weapon_parts": 2 }, "buildSeconds": 1500, "wreckLayout": "miner", "crew": 2, "hold": [120, 120], "price": [180000, 180000], "crewRange": [2, 2] },
        "L": { "cargo": 360, "strength": 1, "toughness": 8, "buildCost": { "hull_plating": 180, "drive_parts": 48, "electronics": 42, "weapon_parts": 6, "refractory_alloy": 6 }, "buildSeconds": 3000, "wreckLayout": "miner", "crew": 8, "hold": [360, 480], "price": [500000, 900000], "crewRange": [6, 12] }
      }
    },
    "salvager": { "classByBand": { "M": "salvager", "L": "salvager" }, "device": "claw_gantry", "aiJobs": ["trader"],
      "templates": {
        "L": { "cargo": 240, "strength": 1, "toughness": 9, "buildCost": { "hull_plating": 180, "drive_parts": 45, "electronics": 50, "weapon_parts": 8 }, "buildSeconds": 3200, "wreckLayout": "salvager", "crew": 8, "hold": [200, 320], "price": [500000, 900000], "crewRange": [6, 12] }
      }
    },
    "courier": { "classByBand": { "S": "courier" }, "device": "express_pod", "aiJobs": ["trader"] },
    "hauler": { "classByBand": { "M": "hauler", "L": "hauler_large" }, "device": "container_spine", "aiJobs": ["trader", "supplier", "convoy", "constructor"] },
    "tug": { "classByBand": { "M": "tug", "L": "tug" }, "device": "tow_clamps", "aiJobs": [] },
    "patrol": { "classByBand": { "S": "patrol", "M": "patrol", "L": "patrol" }, "device": "sensor_mast", "aiJobs": ["patrol"] },
    "survey": { "classByBand": { "S": "survey" }, "device": "survey_array", "aiJobs": [],
      "templates": {
        "S": { "cargo": 20, "strength": 1, "toughness": 2, "buildCost": { "hull_plating": 20, "drive_parts": 8, "electronics": 10, "weapon_parts": 2 }, "buildSeconds": 1000, "wreckLayout": "kestrel", "crew": 1, "hold": [10, 40], "price": [60000, 120000], "crewRange": [1, 2] }
      }
    }
  },
  "makers": {
    "tethys": {
      "kind": "manufacturer",
      "name": "Tethys",
      "doctrine": { "strength": 0.95, "toughness": 1.15 },
      "line": "Heavy-duty: +15% hull, −5% firepower"
    },
    "meridian": {
      "kind": "manufacturer",
      "name": "Meridian",
      "doctrine": { "cargo": 1.15, "strength": 0.9, "toughness": 0.95, "buildCost": 0.9 },
      "line": "Lean: +15% hold, −10% build cost"
    },
    "varro_security": {
      "kind": "manufacturer",
      "name": "Varro",
      "doctrine": { "strength": 1.12, "toughness": 0.9 },
      "line": "Hot: +12% firepower, −10% hull"
    },
    "authority": {
      "kind": "manufacturer",
      "name": "Authority",
      "doctrine": { "cargo": 0.9, "toughness": 1.05, "buildCost": 1.15 },
      "line": "Charter-spec: +5% hull, −10% hold, +15% build cost"
    },
    "holdfast": {
      "kind": "rebuilder",
      "name": "Holdfast",
      "doctrine": { "strength": 0.95, "toughness": 1.05 },
      "line": "Old pattern: +5% hull, −5% firepower"
    },
    "mutual": { "kind": "operator", "name": "Mutual" },
    "raider": { "kind": "operator", "name": "Wreckers" }
  },
  "lines": [
    {
      "id": "tethys.utility",
      "maker": "tethys",
      "role": "utility",
      "hulls": [{ "id": "light_fighter", "band": "S", "legacy": true, "model": "KT-3 Kestrel", "def": "kestrel" }]
    },
    {
      "id": "tethys.miner",
      "maker": "tethys",
      "role": "miner",
      "hulls": [
        { "id": "miner", "band": "M", "legacy": true, "model": "HX-2 Cormorant", "def": "miner", "export": true },
        { "id": "tethys_gannet", "band": "L", "model": "HX-4 Gannet", "def": "tethys_gannet", "sale": false, "lengthM": 120 }
      ]
    },
    {
      "id": "tethys.halcyon",
      "maker": "tethys",
      "hulls": [{ "id": "voss_yacht", "band": "S", "legacy": true, "model": "Halcyon", "def": "voss_yacht", "story": true, "unique": true }]
    },
    {
      "id": "meridian.courier",
      "maker": "meridian",
      "role": "courier",
      "hulls": [{ "id": "meridian_courier", "band": "S", "legacy": true, "model": "MC-2 Isar", "def": "meridian_courier", "sale": false }]
    },
    {
      "id": "meridian.hauler",
      "maker": "meridian",
      "role": "hauler",
      "hulls": [
        { "id": "hauler", "band": "M", "legacy": true, "model": "MF-9 Severn", "def": "hauler", "export": true },
        { "id": "hauler_large", "band": "L", "legacy": true, "model": "MF-36 Danube", "def": "hauler_large" }
      ]
    },
    {
      "id": "varro_security.interceptor",
      "maker": "varro_security",
      "role": "interceptor",
      "hulls": [{ "id": "interceptor", "band": "S", "legacy": true, "model": "SI-7 Jackal", "def": "interceptor", "export": true }]
    },
    {
      "id": "varro_security.gunship",
      "maker": "varro_security",
      "role": "gunship",
      "hulls": [{ "id": "gunship", "band": "S", "legacy": true, "model": "GX-4 Bulwark", "def": "gunship", "export": true }]
    },
    {
      "id": "varro_security.escort",
      "maker": "varro_security",
      "role": "escort",
      "hulls": [
        { "id": "corvette", "band": "M", "legacy": true, "model": "CV-2 Mastiff", "def": "corvette", "wingSize": 5 },
        { "id": "varro_warhound", "band": "L", "model": "FX-1 Warhound", "def": "varro_warhound", "roles": ["patrol"], "sale": false, "lengthM": 140 }
      ]
    },
    {
      "id": "authority.patrol",
      "maker": "authority",
      "role": "patrol",
      "hulls": [{ "id": "cutter", "band": "M", "legacy": true, "model": "CR-1 Vigilance class", "def": "cutter", "sale": false }]
    },
    {
      "id": "authority.secure",
      "maker": "authority",
      "role": "hauler",
      "hulls": [
        { "id": "prisoner_transport", "band": "M", "legacy": true, "model": "PT-3 Clemency class", "def": "prisoner_transport", "story": true }
      ]
    },
    {
      "id": "holdfast.salvager",
      "maker": "holdfast",
      "role": "salvager",
      "hulls": [{ "id": "salvager", "band": "M", "legacy": true, "model": "SV-5 Gleaner", "def": "salvager" }]
    },
    {
      "id": "tethys.salvager",
      "maker": "tethys",
      "role": "salvager",
      "hulls": [{ "id": "tethys_skua", "band": "L", "model": "WB-8 Skua", "def": "tethys_skua", "roles": [], "sale": false, "lengthM": 110 }]
    },
    {
      "id": "holdfast.interceptor",
      "maker": "holdfast",
      "role": "interceptor",
      "hulls": [{ "id": "holdfast_picket", "band": "S", "model": "EC-3 Picket", "def": "holdfast_picket", "roles": ["patrol"], "sale": false, "lengthM": 18 }]
    },
    {
      "id": "holdfast.survey",
      "maker": "holdfast",
      "role": "survey",
      "hulls": [{ "id": "holdfast_wayfinder", "band": "S", "model": "PF-1 Wayfinder", "def": "holdfast_wayfinder", "roles": [], "sale": false, "lengthM": 24 }]
    },
    {
      "id": "holdfast.miner",
      "maker": "holdfast",
      "role": "miner",
      "hulls": [{ "id": "holdfast_delver", "band": "M", "model": "DS-2 Delver", "def": "holdfast_delver", "roles": [], "sale": false, "lengthM": 66 }]
    }
  ],
  "unlined": [{ "id": "guardian_interceptor", "band": "S", "def": "guardian_interceptor", "story": true }],
  "variants": [
    { "id": "tethys_kt3p", "base": "light_fighter", "def": "tethys_kt3p", "role": "miner", "roles": [], "sale": false, "overrides": { "cargo": 40, "strength": 1.9, "toughness": 2.3 } },
    { "id": "varro_mastiff_b", "base": "corvette", "def": "varro_mastiff_b", "role": "bomber", "roles": [], "sale": false, "overrides": { "cargo": 40, "strength": 9, "toughness": 8.1 } },
    { "id": "relic_escort", "base": "holdfast_picket", "def": "relic_escort", "relic": true, "roles": [], "sale": false },
    { "id": "relic_skiff", "base": "holdfast_wayfinder", "def": "relic_skiff", "relic": true, "roles": [], "sale": false },
    { "id": "relic_salvage_tug", "base": "salvager", "def": "relic_salvage_tug", "relic": true, "roles": [], "sale": false }
  ],
  "licences": [{ "maker": "varro_security", "licensee": "authority", "line": "varro_security.interceptor" }],
  "royalty": { "rate": 0.1, "stopAtWar": true },
  "embargo": {
    "enabled": false,
    "economicSurcharge": 0.15,
    "skirmishRefuses": ["L", "XL"],
    "cancelAtWarStart": true,
    "warFallback": true,
    "player": { "economicBelow": 0, "skirmishBelow": -25, "warBelow": -50 }
  },
  "outlawRule": { "bands": ["S", "M"], "exportOnly": true },
  "canBuild": { "enabled": true },
  "capacity": {
    "enabled": true,
    "unitBand": "L",
    "maxUnits": 8,
    "roleUnit": { "trader": 300, "miner": 120, "supplier": 300, "convoy": 300, "constructor": 300, "patrol": 6, "raider": 6 },
    "metric": { "trader": "cargo", "miner": "cargo", "supplier": "cargo", "convoy": "cargo", "constructor": "cargo", "patrol": "strength", "raider": "strength" }
  },
  "flagship": { "lWeight": 0.25, "cap": { "meridian": { "trader": 2 }, "tethys": { "miner": 1 }, "varro_security": { "patrol": 1 } } },
  "buyerMixes": { "meridian": { "trader": { "hauler": 1, "hauler_large": 1 } }, "tethys": { "miner": { "miner": 1, "tethys_gannet": 1 } }, "varro_security": { "patrol": { "interceptor": 0.6, "gunship": 0.4, "varro_warhound": 1 } } }
}
